import SectionWrapper from "./SectionWrapper";

export default SectionWrapper;
